import gql from 'graphql-tag';

export const REGISTER_POINT = gql`
    mutation(
        $member_no: ID!,
        $golf_group_code: String!,
        $golf_code: String!,
        $processing_date: String!,
        $point_type: Int!,
        $point_flag: Int!,
        $action: String,
        $point: Int!,
        $comment: String,
        $valid_start: String,
        $valid_date: String
        ){
            PointRegist (
                member_no: $member_no,
                golf_group_code: $golf_group_code,
                golf_code: $golf_code,
                processing_date: $processing_date,
                point_type: $point_type,
                point_flag: $point_flag,
                action: $action,
                point: $point,
                comment: $comment,
                valid_start: $valid_start,
                valid_date: $valid_date
            ){
                result
            }
        }
`;

export const POINT_BULK_REGIST_FROM_GRANT_POINT_LIST = gql`
    mutation(
        $pointList: [GrantPoint]
    ){
        grantPointAdmin( GrantPointList: $pointList )
        {
            result
        }
    }
`;

export const USE_POINT = gql`
    mutation(
        $PointList: [UseWebPoint]
    ){
        usePointLinkByMemberNo(
            UsePointList: $PointList
        ){
            result
        }
    }
`;

export const RESERVE_USE_POINT_CANCEL = gql`
    mutation(
        $CancelPointByMemberNo: [CancelPointByMemberNo]
    ){
        cancelPointLinkByMemberNoFromAdmin(
            CancelPointList: $CancelPointByMemberNo
        ){
            result
        }
    }
`;
